<template>
  <div id="grid-visita-parent">
    <v-container grid-list-xl fluid>
      <v-layout justify-center>
        <v-flex lg12>
          <v-data-table
            :headers="headers"
            :items="visitas"
            hide-actions="true"
            :rows-per-page-items="rowsPerPageItems"
            class="elevation-1"
          >
            <template v-slot:items="props">
              <td>{{ props.item.tipoVisita.descripcion }}</td>
              <td class="text-xs-left">{{ props.item.fechaVisita }}</td>
              <td class="text-xs-left">
                {{ props.item.estadoVisita.descripcion }}
              </td>
              <v-btn
                depressed
                outline
                icon
                fab
                dark
                color="green darken-4"
                small
                @click="viewVisita(props.item.id)"
              >
                <v-icon>remove_red_eye</v-icon>
              </v-btn>
            </template>
          </v-data-table>
          <!-- LEYENDA TABLA PROVEEDORES -->
          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <div class="text-xs-center">
              <td>
                <template>
                  <v-btn
                    class="btn-sigas"
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="green darken-4"
                    small
                  >
                    <v-icon>remove_red_eye</v-icon> </v-btn
                  >Ver visita
                </template>
              </td>
            </div>
          </v-card-actions>
        </v-flex>
      </v-layout>
      <v-dialog v-model="dialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Esta seguro?</v-card-title>
          <v-card-text>Esta seguro que desea realizar esta accion.</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click="dialog = false"
              >Cancelar</v-btn
            >
            <v-btn color="green darken-1" flat @click="dialog = false"
              >Aceptar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import axios from "axios";
import NewVisitaModal from "./NewVisitaModal.vue";
import GridVisita from "./GridVisitas.vue";
export default {
  name: "grid-visita-parent",
  components: {},
  props: {
    parent: "",
    contratoId: "",
    tipeView: "",
    // fatherLoad:""
  },
  data() {
    return {
      loading: false,
      dialog: false,
      rowsPerPageItems: [20],
      pagination: {
        rowsPerPage: 20,
      },
      headers: [
        {
          text: "Tipo Visita",
          align: "left",
          sortable: false,
          value: "tipoVisita",
        },
        { text: "Fecha", sortable: false, value: "fecha" },
        { text: "Estado", sortable: false, value: "estado" },
        {
          text: "Accion",
          sortable: false,
          value: "",
        },
      ],
      visitas: [],
      idVisita: "",
    };
  },

  mounted() {
    this.contratoId = this.$store.getters.contratoStored;
    this.idVisita = this.$store.getters.visitaStored;
    this.tipeView = this.$route.params.tipeView;
    if (
      (this.tipeView == "consulta" || this.tipeView == "modifica") &&
      this.parent == "HIJA"
    ) {
      this.loadDataVisitatHijo();
    }
    if (
      (this.tipeView == "consulta" || this.tipeView == "modifica") &&
      this.parent == "PADRE"
    ) {
      this.loadDataVisitatPadre();
    }
  },
  computed: {},
  methods: {
    async loadDataVisitatHijo() {
      this.visitas = await this.loadVisitatHijoByFather();
    },
    viewVisita(id) {
      this.loading = true;
      this.reload(id);
    },
    reload(id) {
      this.dialog = false;
      this.$store.commit("visita_state", id);
      this.$parent.$parent.$parent.reloadVisita();
    },
    async loadVisitatHijoByFather() {
      let that = this;
      return await axios
        .get("/visita/" + this.idVisita + "/ver_visita_hijo/" + this.contratoId)
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    async loadDataVisitatPadre() {
      let tempVisita = await this.loadVisitatPadreBySon();
      this.visitas = [tempVisita.visitaRelacionada];
    },

    async loadVisitatPadreBySon() {
      this.idUsuario = this.$store.getters.userLogged.id;
      this.contratoId = this.$store.getters.contratoStored;
      let that = this;
      return await axios
        .get(
          "/visita/" +
            this.idVisita +
            "/" +
            this.contratoId +
            "/" +
            this.idUsuario
        )
        .then((response) => {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>
